import { useEffect, useState } from "react";
import {
  TEACHER_DASHBOARD_NAVIGATION_ELEMENT_TYPE,
  TEACHER_DASHBOARD_REPORTING_SUBHEADING_TAG_NAME,
  TEACHER_DASHBOARD_REPORTING_TITLE_TAG_NAME,
} from "../config/teacherDashboardNavigation";
import {
  DEFAULT_REPORTING_CONFIGURATION,
  REPORTING_CONFIGURATION_IDS,
} from "../config/teacherDashboardReporting";
import { getResolvedTags } from "../services/APIClient";

function mergeReportingConfiguration(titles, subheadings) {
  return Object.fromEntries(
    REPORTING_CONFIGURATION_IDS.map((id) => {
      const fallback = DEFAULT_REPORTING_CONFIGURATION[id];
      return [
        id,
        {
          title: titles?.[id]?.trim() || fallback.title,
          subheading: subheadings?.[id]?.trim() || fallback.subheading,
        },
      ];
    })
  );
}

export default function useReportingConfiguration() {
  const [configuration, setConfiguration] = useState(
    DEFAULT_REPORTING_CONFIGURATION
  );

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      getResolvedTags(
        TEACHER_DASHBOARD_NAVIGATION_ELEMENT_TYPE,
        TEACHER_DASHBOARD_REPORTING_TITLE_TAG_NAME,
        REPORTING_CONFIGURATION_IDS
      ),
      getResolvedTags(
        TEACHER_DASHBOARD_NAVIGATION_ELEMENT_TYPE,
        TEACHER_DASHBOARD_REPORTING_SUBHEADING_TAG_NAME,
        REPORTING_CONFIGURATION_IDS
      ),
    ])
      .then(([titles, subheadings]) => {
        if (!cancelled) {
          setConfiguration(mergeReportingConfiguration(titles, subheadings));
        }
      })
      .catch((error) => {
        console.error("Failed to load Reporting copy:", error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return configuration;
}
